/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automated_Inbox_ResponsesInputs */

const en_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automated Inbox Responses`)
};

const es_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas automáticas de bandeja de entrada`)
};

const fr_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponses automatiques (Boîte de réception)`)
};

const de_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierte Posteingangsantworten`)
};

const ja_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受信トレイの自動応答`)
};

const zh_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动化收件箱回复`)
};

const ar_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ردود صندوق الوارد الآلية`)
};

const id_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respons Kotak Masuk Otomatis`)
};

const it_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposte Automatiche dalla Posta in Arrivo`)
};

const ru_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизированные ответы`)
};

const pt_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas Automáticas de Caixa de Entrada`)
};

const ko_automated_inbox_responses = /** @type {(inputs: Automated_Inbox_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자동화된 수신함 응답`)
};

/**
* | output |
* | --- |
* | "Automated Inbox Responses" |
*
* @param {Automated_Inbox_ResponsesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const automated_inbox_responses = /** @type {((inputs?: Automated_Inbox_ResponsesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automated_Inbox_ResponsesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automated_inbox_responses(inputs)
	if (locale === "es") return es_automated_inbox_responses(inputs)
	if (locale === "fr") return fr_automated_inbox_responses(inputs)
	if (locale === "de") return de_automated_inbox_responses(inputs)
	if (locale === "ja") return ja_automated_inbox_responses(inputs)
	if (locale === "zh") return zh_automated_inbox_responses(inputs)
	if (locale === "ar") return ar_automated_inbox_responses(inputs)
	if (locale === "id") return id_automated_inbox_responses(inputs)
	if (locale === "it") return it_automated_inbox_responses(inputs)
	if (locale === "ru") return ru_automated_inbox_responses(inputs)
	if (locale === "pt") return pt_automated_inbox_responses(inputs)
	return ko_automated_inbox_responses(inputs)
});